import React,{ useEffect } from "react";

import {useSelector, useDispatch}  from "react-redux";
import store from "../../store/Store";
import ProductCard from "./ProductCard";

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';

import {
	FilteredData,
	searchTextFilter,
} from "../../store/Store";




function ProductList(){

	const dispatch = useDispatch();
	const gamedata = useSelector((state)=>state.API.gamedata);
	const filteredData = useSelector((state)=>state.API.filteredData);

	const platform = useSelector((state)=>state.API.platformText);
	const genre = useSelector((state)=>state.API.genreText);
	const searchText = useSelector((state)=>state.API.searchText);

	useEffect(()=>{
		let updatedData = gamedata.filter((item)=>{

			if(genre === 'all'){
				return true;
			}

			if(genre !== 'all' && item.genre === genre){
				return true;
			}

			return false;
		});
		dispatch(FilteredData(updatedData));
	},[genre]);

	useEffect(()=>{
		let updatedData = gamedata.filter((item)=>{

			if(platform === 'all'){
				return true;
			}

			if(platform !== 'all' && item.platform === platform){
				return true;
			}

			return false;
		});
		dispatch(FilteredData(updatedData));
	},[platform]);

	useEffect(()=>{

		let updatedData = gamedata.filter((item)=>{

          if(searchText.length == 0){
          	return true;
          }

          if(item.title.includes(searchText) || item.short_description.includes(searchText)){
          	return true;
          }

			return false;
		});
		dispatch(FilteredData(updatedData));
	},[searchText]);

	return (
		<Box className="ProductListBox">
			<Box className="ProductListContainer">
				{
					filteredData.map((game)=>{

						return <ProductCard key={game.id}
											data={game} />
					})
				}
			</Box>
		</Box>
	);
}

export default ProductList;